import { render, staticRenderFns } from "./CNotificationBar.vue?vue&type=template&id=54c184cd"
import script from "./CNotificationBar.vue?vue&type=script&lang=js"
export * from "./CNotificationBar.vue?vue&type=script&lang=js"
import style0 from "./CNotificationBar.vue?vue&type=style&index=0&id=54c184cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports